import { ProfileChangeEmailPage } from '@/app/pages/profile/profile-change-email-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/profile/change-email')({
  component: ProfileChangeEmailPage,
});
